export default {
    404: "Oups 404 !! La page n'est pas disponible.",
    admin_RemoveItem: "Enlever {v1}",
    admin_AddItem: "Ajouter {v1}",
    admin_Admin: "Adminisrateur",
    admin_Owner: "Contact",
    admin_Client: "Utilisateur",
    admin_Votes: "Votes",
    admin_Profiles: "Profile",
    admin_Organizations: "Organisations",
    admin_showAllPlaces: "Afficher tous les lieux",
    admin_SaveRole: "Sauvegarder le rôle",
    admin_deleteRole: "Supprimer le profil {v1} {v2} ?",
    admin_deleteVote: "Supprimer le vote pour la question \"{v1}\" ?",
    admin_deletePlace: "Supprimer le lieu \"{v1}\" ?",
    admin_deleteOrganization: "Supprimer l'organisation \"{v1}\" ?",
    admin_deletePlaceWarning: "** Tous les votes relatifs à cette question seront supprimés **",
    admin_successMessageAddOwner: "Contact ajouté",
    admin_successMessageAddPlace: "Emplacement ajouté",
    admin_successMessageRemoveOwner: "Propriétaire supprimé",
    admin_successMessageRemovePlace: "Lieu supprimé",
    admin_successMessageRemoveVote: "Vote supprimé",
    admin_successMessageRemoveOrganization: "Organisation supprimée",
    admin_successMessageSaveOrganization: "Organisation sauvegardée",
    admin_successMessageChangeRole: "Rôle modifié",
    admin_Stickers: "Étiquettes",
    admin_ChangeStatusToCancelled: "Changer le statut en \"Annulé\" ?",
    admin_ChangeStatusToSent: "Changer le statut en \"Envoyé\" ?",
    admin_ChangeStatusToCompleted: "Changer le statut en \"Terminé\" ?",
    admin_adminVotesShowAll: "Afficher tous les votes",
    admin_searchByName: "Recherche par noms",
    admin_signInAs: "Connectez-vous en tant que : {v1} ?",
    admin_ReturnToOriginalAccount: "Retour au compte d'origine : {v1} ?",
    admin_closeAccountRequests: "Demandes de fermeture de compte",
    admin_landingQuestions: "Questions sur l'atterrissage",
    admin_firstName: "Nom",
    admin_lastName: "Prénom",
    admin_contactEmail: "Email de contact",
    admin_phone: "Téléphone",
    admin_success: "Succès",
    admin_userCreated: "Un nouvel utilisateur a été créé",
    admin_sortBy: "Recherche par",
    admin_sortByName: "Nom",
    admin_sortByAdded: "Ajouté",
    admin_sortByUpdated: "Mise à jour",
    admin_sortByEmail: "Email",
    admin_sortByCreated: "Créé",
    adminPanel: "Panneau administratif",
    admin_Add: "Ajouter",
    admin_Places: "Lieux",
    admin_UnQuestions: "Questions non liées",
    admin_ChooseYourPlace: "Sélectionnez l'emplacement de votre entreprise",
    admin_NothingFound: "Rien trouvé",
    admin_Delete: "Suprimer",
    admin_delete_image: "Voulez-vous supprimer des images ?",
    admin_successImageDelete: "L'image a été supprimée",
    Track_vote: "Pour suivre vos votes, veuillez vous connecter :",
    Logout: "Déconnexion",
    Sync_status: "Status de  la synchronisation",
    Success: "Succès",
    Error: "Erreur",
    Back: "Retour",
    No_votes: "Vous n'avez pas encore de votes",
    statusMessage: "Je travaille...",
    Save: "Sauvegarder",
    sign_in_to_connect: "Veuillez vous connecter pour associer cette question à votre entreprise.",
    yes: "Oui",
    no: "Non",
    YourVotes: "Vos votes",
    OtherVotes: "Les votes des autres utilisateurs",
    AirVotes: "AirVotes",
    Change: "Modifier",
    Submit: "Soumettre",
    Cancel: "Annuler",
    CancelRequest: "La demande a été annulée",
    ChangedYourMind: "Vous avez changé d'avis ? Choisissez un autre vote !  Notez que la date et l'heure resteront inchangées.",
    NotConnectedPlaceToAirVote: "Cet endroit n'est actuellement pas connecté a Air-vote",
    From: "Depuis",
    To: "Jusqu'à",
    bflow_BusinesConnectQuestion: "Veuillez choisir votre entreprise pour relier la question \"{v1}\".",
    bflow_BusinesConnectQuestionSuccess: "La demande a été correctement assignée",
    bflow_ChoosePlace: "Veuillez choisir un lieu pour associer la question \"{v1}\".",
    bflow_AddQuestionSuccess: "Question ajoutée",
    bflow_BecameOwnerPlace: "Terminé. Vous êtes maintenant un contact désigné pour \"{v1}\".",
    bflow_BecameOwnerPlaceConfirm: "Vous inscrire comme contact désigné pour \"{v1}\" ?",
    bflow_ConfirmConnectQuestionToPlace: "Ajouter la question \"{v1}\" à l'emplacement \"{v2}\" ?",
    bflow_ConfirmConnectQuestionToPlacebelow: "Ajouter la question \"{v1}\" à l'emplacement ci-dessous ?",
    bflow_ConnectedQuestion: "Question de connexion...",
    bflow_finishBusinesFlow: "Voulez-vous sortir ?",
    bi_Name: "Nom",
    bi_OfficialName: "Prénom",
    bi_ContactEmail: "Email de contact",
    bi_Phone: "Téléphone",
    bi_Password: "Mot de passe",
    bi_Edit: "Editer",
    bi_Address: "Adresse",
    bi_WebsiteUrl: "Url du site web",
    bi_validation_OrganizationRequired: "Le nom de l'organisation est obligatoire",
    bi_validation_Email: "Format d'email incorrect",
    bi_validation_Phone: "Format de téléphone incorrect",
    bi_validation_Website: "Format du site web incorrect",
    bi_first_Name: "Nom",
    bi_last_Name: "Prénom",
    bi_confirm_email: "Adresse email non confirmée",
    bi_resend_email: "Renvoyer l'email d'autorisation",
    bi_resend_email_success: "L' email de confirmation a été envoyé avec succès",
    bi_set_password: "Définir le mot de passe",
    bi_change_password: "Changez votre code secret",
    bi_cancel_password: "Annuler le changement de mot de passe",
    bi_current_password: "Mot de passe actuel",
    bi_new_password: "Nouveau mot de passe",
    bi_retype_password: "Saisir à nouveau le nouveau mot de passe",
    bi_save_password: "Sauvegarder le nouveau mot de passe",
    bi_password_change_success: "Succès du changement de mot de passe",
    own_use_w3w: "Géolocalisation -> Utiliser what3words",
    own_email_Confim: "Veuillez confirmer votre adresse e-mail",
    own_anyConnectedPlace: "Aucun site d'entreprise n'est encore connecté",
    own_myQuestions: "Mes questions",
    own_createQuestion: "Créer une question",
    own_orderStickers: "Commander des smileys QR",
    own_selectRange: "Sélectionner une gamme",
    own_today: "Aujourd'hui",
    own_last7days: "7 derniers jours",
    own_lastMonth: "Le mois dernier",
    own_allTime: "Depuis le début",
    own_custom: "Personnalisé",
    own_Search: "Recherche",
    own_showMore: "Montrer plus",
    own_showLess: "Montrer moins",
    own_Locations: "Placements",
    own_Questions: "Questions",
    own_Total: "Total",
    own_Happy: "Heureux",
    own_SoSo: "Pas terrible",
    own_Sad: "Triste",
    own_green: "Vert",
    own_yellow: "Jaune",
    own_red: "Rouge",
    own_EditQuestion: "Modifier la question",
    own_DownloadPDF: "Générer des smileys QR",
    own_DownloadPDFMobile: "Générer des QR",
    own_OrderSticker: "Commander un autocollant QR",
    own_DeleteQuestion: "Supprimer la question",
    own_DownloadAndPrint: "Télécharger et imprimer",
    own_OrderStickerFrom: "Commander des smileys QR d'AirVote",
    own_OrderStickerDescription: "Les smileys QR d'AirVote sont imprimés sur du vinyle résistant aux intempéries. Ils sont livrés dans un délai de 10 à 15 jours. L'état de la commande est indiqué sur le tableau de bord",
    own_DeliveryAddress: "Entrez l'adresse de livraison",
    own_RecipientName: "Nom du destinataire",
    own_RecipientPhone: "Téléphone du destinataire",
    own_RecipientEmail: "Email du destinataire",
    own_Comment: "Commentaire",
    own_ShowZeroVotes: "Afficher les votes nuls",
    own_PlaceOrder: "Passer la commande",
    own_CreateNew: "Créer une nouvelle question AirVote",
    own_EnterQuestion: "Entrez votre question AirVote ici",
    own_SpecifyLocation: "Précisez le placement",
    own_DownloadPDF_Title: "Question ajoutée",
    own_DownloadPDF_Description: "Vous pouvez maintenant télécharger un PDF de la question. Pour en commander un à AirVote®, utilisez l'élément \"Générer des smileys QR\" dans le menu des questions.",
    own_DownloadPDF_EditTitle: "Question mise à jour.",
    own_SureTODelete: "Vous avez supprimé votre question ?",
    own_DownloadSticker: "Télécharger les QR smileys PDF",
    own_StickerProportion: "électionnez la disposition des smileys qui correspond à vos besoins",
    own_PanelTextLeaflet: "Compact",
    own_PanelTextBusiness: "Carte de visite",
    own_PanelTextExtended: "Standard",
    own_PanelSubtitleLeaflet: "Imprimez une petite carte à distribuer aux clients ou placez-la au dos de votre carte de visite.",
    own_PanelSubtitleExtended: "Imprimez-le sur un autocollant ou une affiche. Placez-le à portée de main des clients",
    own_PanelSubtitleBusiness: "Mise en page plus compacte pour les cas où vous avez besoin d'imprimer et de distribuer les smileys QR AirVote sous forme de cartes de visite.",
    own_AllVotesWillDeleted: "Tous les votes pour cette question AirVote® seront supprimés.",
    own_HasBeenDeleted: "Question supprimée",
    own_DontForgetCreate: "N'oubliez pas d'en créer une nouvelle !",
    own_OrderHasBeenPlaced: "Votre commande a été passée.",
    own_KeepTrack: "Le statut de la commande sera affiché sur le tableau de bord.",
    own_Manage: "Gérer",
    own_Title: "Bienvenue au panel d'entreprises AirVote !",
    own_Business: "Votre entreprise",
    own_Subitle: "Indiquez le nom de votre entreprise pour pouvoir créer des questions. Vous pouvez le modifier à tout moment par la suite.",
    own_Address: "Adresse",
    own_BusinessName: "Nom de votre entreprise",
    own_SaveBtn: "Sauvegarder et continuer",
    own_SaveBtnWithQuestion: "Enregistrez et obtenez mes smileys QR",
    own_CanNotFind: "Je ne trouve pas mon entreprise",
    own_PleaseStartWriting: "Veuillez commencer à écrire le nom de votre entreprise et le choisir dans la liste déroulante.",
    own_filter_placeholder: "Commencez à taper pour filtrer",
    own_AssetId: "ID d'élément",
    AnalyticSettings: "Options d'analyse",
    AnalyticDescription: "En configurant ceci, vous ajustez la façon dont les données sont affichées dans le tableau de bord d'analyse.",
    AnalyticIndex: "Index analytique préféré",
    AnalyticWhatMean: "Qu'est-ce que cela signifie ?",
    AnalyticWhatMeanIndex: "Pourquoi l'index est-il une bonne idée ?",
    AnalyticWhatMeanIndexDescription: "L'indice fournit une mesure objective pour suivre les tendances dans le temps et comparer les performances dans différents domaines.",
    AnalyticWhatMeanIndexValue: "",
    AnalyticIndexPromouterScore: "・Net Promoter Score : #votes \"heureux\" * 100% + #votes \"moyennement\" * 0% - #votes \"tristes\" * 100%. Le score le plus élevé est 100. Le score le plus bas est -100.",
    AnalyticIndexAirVoteScore: "・AirVote Score : #Votes \"heureux\" * 100% + #Votes \"moins bien\" * 50%. Le score le plus élevé est 100. Le score le plus bas est 0.",
    ThereIsAnError: "Veuillez entrer la valeur correcte",
    StickerStatus: "Statut de l'étiquette",
    Requested: "Demandé",
    Sent: "Envoyé",
    Cancelled: "Annulé",
    Close: "Fermer",
    welcomeModalTitle: "Trouvez votre entreprise sur la carte",
    welcomeModalSubtitle: "Nous utilisons les données de Google pour vous aider à inscrire votre entreprise dans AirVote",
    welcomeModalSearchYouBusinass: "Recherchez votre entreprise en utilisant la saisie en haut de l'écran",
    welcomeModalPickOnMap: "Ou choisissez-la sur la carte",
    welcomeModalNotOnGoogle: "Votre entreprise n'est pas sur Google ? Petits problèmes ? Écrivez-nous à l'adresse suivante",
    mapTipsSearch: "Recherchez votre entreprise par son nom",
    mapTipsPick: "Ou choisissez-la sur la carte",
    OK: "OK",
    Location: "Placement",
    Question: "Question",
    companyManagement: "Gestion de l'entreprise",
    sites: "Sites d'entreprise",
    site: "Site",
    SitesDescription: "Les sites d'entreprise sont les différentes branches ou sites de votre société. Un ou plusieurs responsables de site peuvent être affectés à chaque site pour co-administrer le système AirVote du site.",
    addNewSite: "Ajouter un site",
    siteDetail: "Détails du site",
    questionsAndAnalytics: "Questions et analyses",
    companyInformation: "Informations sur l'entreprise",
    companyManagers: "Gestionnaires de l'entreprise",
    saveChanges: "Enregistrer les modifications",
    companyManagersDescription: "Vous pouvez désigner d'autres responsables d'entreprise pour co-administrer le système AirVote de votre entreprise.",
    Invite: "Inviter",
    EnterEmailToAssignCompanyManager: "Entrez l'email pour assigner un chef d'entreprise",
    enterSeveralEmailByComma: "Vous pouvez entrer plusieurs emails séparés par une virgule",
    Pending: "En attente",
    Accepted: "Accepté",
    Remove: "Supprimer",
    ActiveManagers: "Gestionnaires actifs",
    NoOthersCompanyManagersAssigned: "Pas d'autres gestionnaires d'entreprise affectés",
    removeManager: "Supprimer le manager : {v1} ?",
    all: "Tous",
    editManagers: "Modifier les responsables",
    assignManagers: "Affecter des responsables",
    viewAnalytic: "Voir les analyses",
    deleteSite: "Supprimer un site",
    deleteSiteConfirm: "Supprimer le site : {v1} ?",
    siteManagers: "Responsables du site",
    SiteManagersNotAssigned: "Non attribué",
    siteName: "Nom du site",
    siteAddress: "Adresse du site",
    Website: "Site web",
    Email: "Email",
    Alias: "Alias",
    EditPhoto: "Modifier la photo",
    SitePhoto: "Photo du site",
    AirVoteSuggestsTitle: "AirVote suggère",
    SearchForQuestion: "Questions suggérées",
    UseQuestion: "Utiliser la question",
    ImagesSupportedParams: "Les images aux formats PNG et JPG sont prises en charge. La taille maximale de la photo est de 5 Mo",
    UploadFile: "Télécharger le fichier",
    RemovePhoto: "Supprimer la photo",
    ReturnBtn: "Retourner à",
    RemovePhotoConfirm: "Supprimer la photo du site ?",
    RemovePhotoSuccess: "Photo supprimée",
    WrongFormat: "Mauvais format. Veuillez utiliser PNG ou JPG",
    PhotoOverweight: "La photo est plus de {v1}Mb",
    cancelInvite: "Annuler l'invitation : {v1} ?",
    createSiteMap: "Créer un nouveau site en utilisant cet endroit : {v1} ?",
    chooseNewPlaceFrOrganization: "Veuillez choisir un nouveau lieu pour votre entreprise.",
    MyBusinessIsMultipleSites: "Mon entreprise a plusieurs sites",
    goingToMultipleSitesMode: "Demandez le mode site multiple pour votre organisation ?",
    by_questions: "Questions",
    by_sites: "Sites",
    by_locations: "Placements",
    groupBy: "Regrouper par",
    Diagram: "Diagramme",
    ID: "ID",
    Filter: "Filtrer",
    Comments: "Commentaires",
    ownLastVotes: "Derniers votes",
    IndexAirvote: "Indice AirVote",
    TotalVotes: "Total des votes",
    Notifications: "Alertes",
    CloseAccount: "Fermer mon compte",
    DowngradeToClient: "Déclassez-moi en client",
    sendAlertEvery: "Envoyer une notification chaque",
    SendNotificationEach2: "vote(s)",
    IncludeSosoVotes: "Inclure les votes so-so",
    SMS: "SMS",
    Reports: "Rapports",
    daily: "Quotidiennement",
    weekly: "Hebdomadaire",
    monthly: "Mensuels",
    SendRequestToClose: "Fermer votre compte ?",
    SendRequestToRestore: "Envoyer une demande de restauration de compte ?",
    RestoreAccount: "Restaurer le compte",
    DowngradeProfileToClient: "Passer du profil au rôle de client ?",
    ProfileSettings: "Paramètres du profil",
    savedSuccessfuly: "Paramètres enregistrés avec succès",
    Message: "Message",
    NoData: "Pas de données",
    Decline: "Refuser",
    Approve: "Approuver",
    DeclineRequest: "Refuser la demande de suppression du compte ?",
    ApproveRequest: "Approuver la demande de suppression du compte ?",
    MyPlaces: "Mes sites",
    EmptySiteTitle: "Votre entreprise n'a pas de sites configurés. Ajoutez-en un !",
    EmptySiteDescription: "Les sites sont les différentes branches ou bureaux de votre entreprise. Chaque site peut se voir attribuer un ou plusieurs administrateurs de site. L'administrateur d'un site peut modifier les détails du site et avoir accès aux analyses du site.",
    accountSettings: "Paramètres du compte",
    accountSettingsDescription: "Modifier les données de votre profil, gérer les notifications et les rapports que vous recevez",
    otherOptions: "Autres options",
    UploadNewPhoto: "Télécharger une nouvelle photo",
    receiveBadVotesViaSms: "Vous pouvez recevoir des notifications concernant les votes \" triste \" ou \" moyen \" par e-mail ou SMS.",
    Threshold: "Seuil",
    SoSoVotes: "Votes mitigés",
    Channel: "Chaîne",
    DisableAllNotifications: "Désactiver toutes les notifications",
    EnableAllNotifications: "Activer toutes les notifications",
    sendDetailedReportToEmail: "Nous pouvons envoyer des rapports détaillés à votre adresse électronique",
    Regularity: "Régularité",
    nothingSelected: "Rien de sélectionné",
    allNotificationsDisabled: "Toutes les notifications sont désactivées",
    createNewUser: "Créer un nouvel utilisateur",
    exportRawData: "Exporter les données brutes",
    exportTo: "Exporter vers",
    tab_Map: "Carte",
    smileysMailTitle: "Vos QR smileys AirVote sont en route !",
    smileysMailSubtitle: "Vérifiez {v1} pour vos QR smileys. Si vous ne les recevez pas dans les minutes qui suivent, vérifiez votre dossier de courrier indésirable.",
    smileysMailDownload: "téléchargez ici",
    smileysMailChecklist: "Vous pouvez désormais vous connecter à votre panneau d'entreprise. Utilisez-le pour :",
    smileysMailChecklistFirst: "Vérifier les rapports de vote des clients en temps réel",
    smileysMailChecklistSecond: "Créer et imprimer des questions supplémentaires",
    smileysMailChecklistThird: "Configurer des alertes en temps réel sur les zones problématiques",
    smileysMailChecklistFourth: "Afficher des analyses avancées",
    smileysMailChecklistMore: "...et bien plus encore !",
    smileysMailChecklistBtn: "Amenez-moi à mon panneau d'affaires maintenant",
    smileysMailChecklistBack: "Retour au site web",
    signIn_enter: "Entrez, en utilisant",
    signIn_or: "ou",
    signIn_difficulties: "Vous rencontrez des difficultés ?",
    signIn_contact: "Contactez nous à",
    question_suggestions_freq_title: "Récemment utilisé",
    signIn_signIn_title: "S'inscrire",
    signIn_signUp_title: "S'inscrire",
    signIn_enter_using_email: "ou entrez en utilisant votre email",
    signIn_email_hint: "Adresse électronique",
    signIn_password_hint: "Mot de passe",
    signIn_signInBtn: "Se connecter",
    signIn_forgotPass_btn: "Vous avez oublié votre mot de passe ?",
    signIn_noCreditReq: "Aucune carte de crédit requise",
    signIn_firstName_hint: "Votre prénom",
    signIn_lastName_hint: "Nom de famille",
    signIn_signUp_btn: "S'inscrire",
    signIn_useMedia: "Ou inscrivez-vous en utilisant les médias sociaux",
    signIn_agreeTo: "J'accepte les conditions d'AirVote",
    signIn_tAndC: "Conditions générales d'AirVote",
    signIn_recoverPassword: "Récupérer votre mot de passe",
    signIn_recoverPassSubtitle: "Entrez l'email utilisé pour vous connecter à votre compte.",
    signIn_recoverPassContinue: "Continuer",
    signIn_recoverPassBack: "Retour à la page de connexion",
    signIn_protected: "Ce site est protégé par reCAPTCHA et par la politique de confidentialité Google",
    signIn_privacyPolice: "Politique de confidentialité",
    signIn_and: "Et",
    signIn_Terms: "Conditions d'utilisation",
    signIn_Login: "Se connecter en utilisant {v1}",
    signIn_Register: "S'enregistrer en utilisant {v1}",
    signIn_RegisterWithEmail: "S'inscrire avec une adresse e-mail",
    signIn_RegisterWithQuestion: "Suivant : À propos de mon entreprise",
    signIn_SeparatorText: "OU",
    signIn_TitleWithQuestion: "Inscrivez-vous à AirVote pour :",
    signIn_ChecklistFirst: "Recevoir vos QR smileys par e-mail",
    signIn_ChecklistSecond: "Accéder au panel de votre entreprise pour suivre les réponses (votes).",
    auth_confirm_email_confirming: "Confirmer votre email 🔄",
    auth_confirm_email_confirmed: "Email confirmé avec succès ✅\nRedirection vers le panneau d'affaires...",
    auth_confirm_email_already_confirm: "Votre email a déjà été confirmé",
    login_btn_link: "Connectez-vous à",
    login_btn_text: "au tableau de bord de votre entreprise",
    password_validation_min_length: "Longueur minimale de 6 caractères",
    password_validation_uppercase: "Une lettre majuscule",
    password_validation_lowercase: "Une lettre minuscule",
    loadPdfProgress: "Veuillez attendre que votre PDF soit généré 🔄",
    showManagePopupTitle: "Gérer les questions, télécharger les smileys QR",
    showManagePopupSubtitle: "Bienvenue sur le panneau d'entreprise d'AirVote ! Chaque bloc que vous voyez à l'écran est une question que vous avez configurée. Utilisez l'icône pour gérer les questions : modifier, supprimer ou télécharger les smileys QR au format PDF.",
    showFeedbackPopupTitle: "Commencez à recevoir des commentaires",
    showFeedbackPopupSubtitle: "Lorsque vous avez imprimé vos smileys QR, placez-les à un endroit où ils seront vus par le client. Chaque vote est immédiatement affiché dans votre panneau commercial",
    showAlertsPopupTitle: "Configurez et recevez des alertes",
    showAlertsPopupSubtitle: "Félicitations pour avoir obtenu vos premiers votes ! Savez-vous que vous pouvez recevoir des notifications pour chaque vote sur votre mobile ou par e-mail ? Utilisez votre page de profil pour configurer les règles de notification",
    driverMainText: "Vous n'avez accès qu'à l'écran de vote. Veuillez scanner l'autocollant",
    helpCenterTitle: "Centre d'aide",
    orderBannerSubtitle: "Nous pouvons imprimer vos questions sur un vinyle imperméable et les envoyer partout dans le monde.",
    orderBannerBtn: "Commander des autocollants",
    orderStickersBtn: "Commander des autocollants QR",
    orderPageBtn: "Commençons",
    orderSelectTitle: "Sélectionnez les questions que vous souhaitez imprimer",
    orderBusinessSite: "Site de l'entreprise",
    orderBusinessPlacement: "Placement",
    orderTotal: "Total de la commande",
    orderDelivery: "Livraison",
    orderDeliveryText: "Gratuit",
    orderFormTitle: "Terminez votre commande",
    orderFormSubtitle: "Le délai de livraison approximatif est de 10 à 15 jours",
    orderShippingTitle: "Expédition en dehors des États-Unis ou de l'Europe",
    orderShippingSubtitle: "Contactez AirVote pour obtenir un devis incluant tous les frais d'expédition et de douane.",
    orderQuote: "Obtenir un devis",
    orderSuccessPayment: "Votre commande a été créée avec succès. Nous vous contacterons bientôt pour vous fournir un devis",
    orderSuccessPayPal: "Votre commande a été payée avec succès. Vous serez informé de l'expédition de votre commande.",
    orderCountryLabel: "Pays",
    orderStickerSizeLabel: "Taille de l'autocollant",
    orderBtnToDashboard: "Accéder au tableau de bord",
    unsubscribeBtn: "Désabonner",
    unsubscribeSaveBtn: "Mettre à jour les paramètres",
    unsubscribePopupText: "Vous vous désabonnez maintenant",
    orderShippingBlockTitle: "Informations sur la livraison",
    title_404: "La page que vous essayez d'atteindre n'est pas disponible.",
    btn_404: "Revenir en arrière",
    dataReportPopup: "Il n'y a pas de données. Veuillez modifier vos filtres ou choisir une autre plage de dates.",
    dataReportPopupMobileXLSX: "Ce fichier contient uniquement les données de vote. Pour les analyses et les graphiques détaillés des votes, veuillez utiliser le tableau de bord AirVote sur PC ou Mac.",
    manageScreenQuestion: "Question",
    manageScreenLocation: "Description de la localisation",
    manageSetGeolocation: "Définir la géolocalisation",
    manageSetAsset: "Actif",
    manageGeolocation: "Géolocalisation",
    manageUpdateBtn: "Mise à jour",
    manageLatitude: "Latitude",
    manageLongitude: "Longitude",
    manageGPSAccuracy: "Précision GPS {v1}m",
    manageGPSLocation: "Localisation GPS",
    manageGPSAllowText: "Veuillez autoriser air-vote.com à récupérer les données de localisation GPS de votre téléphone.",
    manageGPSAllowSubtitle: "* nous ne l'utiliserons que lorsque vous visiterez cette page pour mettre à jour la géolocalisation de la question",
    manageGPSPopupLongDistance: "Vos coordonnées GPS actuelles sont très éloignées de l'emplacement de l'autocollant précédent {v1}m",
    manageGPSPopupBadAccuracyAndLongDistance: "Vos coordonnées GPS actuelles sont très éloignées de l'emplacement de l'autocollant précédent {v1}m et ont une mauvaise précision {v2}m",
    manageGPSPopupBadAccuracy: "Vos coordonnées GPS actuelles ont une mauvaise précision ({v1}m)",
    manageGPSPopupSureNewCoords: "Etes-vous sûr d'utiliser les nouvelles coordonnées ?",
    manageGPSPopupUseNewCoordsBtn: "Utiliser les nouvelles coordonnées",
    manageGPSPopupChangeManuallyBtn: "Modifier manuellement",
    manageMapBtn: "Utiliser cet emplacement",
    manageSaved: "Sauvegardé",
    manageCopiedToClipboard: "Copié dans le presse-papiers",
    manageGPSUnableToFetchMsg: "Nous n'avons pas pu récupérer l'emplacement GPS. Veuillez réessayer",
    manageGPSUnavailable: "L'emplacement GPS n'est pas disponible. Veuillez réessayer ou contacter notre équipe d'assistance",
    manage_back_to_yard: "Back to yard",
    w3wTitle: "Un moyen simple de décrire votre position n'importe où dans le monde",
    w3wLearnMore: "En savoir plus",
    unassignedQuestion: "Les questions non attribuées",
    own_votesNotFound: "Il semble que vous n'ayez pas de votes récents 😔\n\nVeuillez vous assurer que vos autocollants AirVote sont toujours à leur place et fonctionnent correctement.",
    own_votesQuestion: "Question:",
    own_votesPlacement: "Placement:",
    own_votesPriorVotes: "Les votes antérieurs de l'utilisateur:",
    own_votesUser: "Utilisateur:",
    own_votesComment: "Commentaire:",
    own_votesContactInfo: 'Informations de contact:',
    bulkPlacement: "Modification du placement en bloc",
    bulkPlacementPopupSavedQuestions: "Questions sélectionnées",
    bulkPlacementPopupSelectAll: "Sélectionner tout",
    bulkSuccessfulPlaceEdit: "Le placement a été modifié avec succès",
    showAllVotes: "Afficher tous les votes récents",
    bulkInputPlaceHolder: "Nouveau placement",
    copy: "Copier",
    telegramPopupGroup: "Ajouter Bot au groupe",
    telegramPopupPrivate: "Ajouter Bot au chat privé",
    telegramPopupTitle: "Votre hachage",
    setupTelegramBtn: "Configurer Telegram Bot",
    telegramHashAvailable: "Le hachage actuel est disponible pendant 1 heure",
    moreOptiosPopuoTitle: "Plus d'options",
    emailSignature: 'Communications électroniques',
    emailSignatureSubtitle: "Copiez/collez les smileys dans vos e-mails, factures électroniques ou pour toute présentation en ligne",
    emailSignatureTitle: 'Comment fonctionne AirVote pour vous jusqu\'à présent ?',
    emailSignatureClick: 'Cliquez sur un smiley pour laisser un commentaire',
    emailSignatureCopyLink: 'Copier le lien',
    singleEmailSignaturePageTitle: 'Ajoutez AirVote E-Smiley à vos communications',
    copied: 'Copié',
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Journal du service',
    airLeadSubmittedBy: 'Proposé par:',
    airLeadChooseDriver: 'choisir le chauffeur',
    airLeadCompanyName: 'Nom de la compagnie',
    airLeadSiteType: 'Type de site',
    airLeadOpportunity: 'Opportunité',
    airLeadCustomer: 'Client',
    airLeadAdditionalNotes: 'Notes complémentaires',
    airLeadMoreService: 'Plus de services',
    airLeadMoreUnits: 'Plus d`unités',
    airLeadSink: 'Un évier',
    airLeadCallThem: 'Pour les appeler',
    airLeadSubmitALead: 'Soumettre une piste',
    airLeadHideLeads: 'Masquer les prospects fermés',
    airLeadShowAllLeads: 'Afficher tous les prospects',
    airLeadDashboardDate: 'Date',
    airLeadDashboardType: 'Taper',
    airLeadDashboardStatus: 'Statut',
    airLeadDashboardStatusNotes: 'Notes d`état',
    airLeadDashboardLastActionDate: 'Date de la dernière action',
    airLeadDashboardActionBy: 'Action par',
    airLeadDashboardSalesFollowUp: 'Suivi des ventes',
    airLeadDashboardNotClosed: 'Pas fermé',
    airLeadDashboardClosedWon: 'Fermé/Gagné',
    airLeadDashboardNotQualified: 'Non qualifié',
    airLeadDashboardCommission: 'Commission',
    airLeadDashboardNotLeadsFound: 'Aucune piste trouvée',
    airLeadDashboardRefresh: 'Rafraîchir',
    airLeadInfoPopupDriver: 'Chauffeuse',
    airLeadInfoPopupNotes: 'Remarques',
    airLeadInfoPopupLocation: 'Emplacement',
    airLeadInfoPopupViewOnMap: 'Voir sur la carte',
    airLeadInfoPopupServices: 'Prestations de service',
    airLeadStatusAndCommissionError: 'Veuillez saisir les notes de statut et la commission pour fermer un prospect',
    airLeadStatusNotesError: 'Veuillez saisir des notes de statut pour fermer un prospect',
    airLeadNewCustomerLead: 'Nouveau responsable client',
    airLeadExistingCustomer: 'Chef de file client existant',
    airLeadPleaseChooseDriver: 'Veuillez choisir un chauffeur',
    airLeadPleaseCompanyInfo: 'Veuillez saisir les informations de l`entreprise',
    airLeadPleaseCustomerInfo: 'Veuillez saisir les informations client',
    airLeadGoodLack: 'Bonne chance pour votre avance! \nMerci d`avoir aidé à attirer de nouveaux clients !',
    airLeadCommission: 'La commission doit être supérieure à 0',
    airLeadNumberShouldContains: 'Le numéro doit contenir moins de 3 chiffres',
    sldPlaceGuid: 'Guide de lieu',
    sldOrganizationGuid: 'Guide d\'organisation',
    sldGetPlaceConfig: 'Recharger la configuration',
    sldEnableDetails: 'Activer les détails de niveau 2d',
    sldBasicConfig: 'Configuration de base',
    sldScreenTitle: 'Titre de l\'écran',
    sldScreenSubTitle: 'Sous-titre',
    sldScreenBackground: 'Fond d\'écran :',
    sldMaxCount: 'Nombre maximum d\'éléments sélectionnés',
    sldEnterForUnlimited: 'Entrez 0 pour illimité',
    sldShowComment: 'Toujours afficher le commentaire',
    sldBlocks: 'Blocs:',
    sldText: 'Texte',
    sldGreenScreen: 'Écran vert',
    sldYellowScreen: 'Écran jaune',
    sldRedScreen: 'Écran rouge',
    sldOverrideSettings: 'Remplacer les paramètres de base',
    sldOverrideBlocks: 'Remplacer les blocs de base',
    sldSecondLevelDetails: 'Détails de deuxième niveau',
    configMissingMsg: 'La configuration est manquante, voulez-vous l\'activer',
    sldTakeFromPlace: 'Prendre sur place',
    sldChooseAnIcon: 'Choisissez une icône',
    sldEditIcon: 'Icône d\'édition',
    sldUploadIcon: 'Télécharger une nouvelle icône',
    sldIconTag: 'Balise d\'icône',
    sldPleaseFillInput: 'Veuillez remplir le champ',
    sldDefaultText: 'Texte par défaut',
    sldChooseIcon: 'Veuillez choisir une icône',
    sldSaveAndAddMore: 'Sauvegarder et ajouter plus',
    sldAddIcon: 'Ajouter une icône',
    sldAreYouSure: "Allez-vous supprimer cette image?",
    enableServiceLog: 'Activer la configuration du journal des services',
    serviceLogRequirePin: 'Nécessite une broche',
    serviceLogInfoPopup: 'Afficher la fenêtre d\'information sur le journal des services',
    serviceLogPlacementEdit : 'Montage du placement du spectacle',
    commentViewOnMap: 'Voir sur la carte',
    sldTagInUseErrorTitle: "Impossible d'effectuer cette action. L'étiquette est en cours d'utilisation :",
    tab_AssetsMap: "Carte des toilettes",
    settings_checkbox_GoogleReviewAlerts: "Google review alerts"
}
